import templateUrl from './maintenance-admin-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administration: '<',
    administrations: '<',
    units: '<',
    animalTypes: '<',
    frequencies: '<',
    submitTitle: '@',
    unitsDisplay: '<',
    administrationChanged: '&',
    index: '<',
    showAdditionalButton: '<'
  },
  controller: class MaintenanceAdminFormComponent {
    constructor(AnimalTypeService, EventEmitter) {
      'ngInject';

      Object.assign(this, {
        AnimalTypeService,
        EventEmitter
      });
    }

    onSubmit(shouldClose) {
      const administration = {
        Isloading: false,
        ...this.administration
      };

      if (!administration.DoseId) {
        this.administrations.push(administration);
      }

      this.administrationChanged(
        this.EventEmitter({
          administration,
          index: this.index,
          shouldClose
        }));

      this.validateDuplicates();
    }

    getMinimumAnimalWeight(species) {
      return this.AnimalTypeService.minimumAnimalWeight(species);
    }

    getMaximumAnimalWeight(species) {
      return this.AnimalTypeService.maximumAnimalWeight(species);
    }

    calculateAdminDays() {
      return Math.round(this.units / (this.administration.DoseAmount * this.administration.DosePerDay));
    }

    validateDuplicates() {
      let isValid = true;

      if (this.administration) {
        const arrayIndex = this.administrations.findIndex(d =>
          d.Isloading === false
          && d.Species === this.administration.Species
          && d.MinWeight === this.administration.MinWeight
          && d.MaxWeight === this.administration.MaxWeight
          && d.DoseAmount === this.administration.DoseAmount
          && d.DosePerDay === this.administration.DosePerDay
        );

        if (arrayIndex !== -1 && arrayIndex !== this.index) {
          isValid = false;
        }
      }

      this.maintenanceAdministrationForm.$setValidity('duplicate', isValid);
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/maintenance-admin-form/maintenance-admin-form.component.js